/**
 * Social Media Configuration - Single source of truth
 */
import { Facebook, Instagram } from "lucide-react";

// X (Twitter) icon component
export const XIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

// Social Media Accounts
export const SOCIAL_ACCOUNTS = {
  facebook: {
    name: "Facebook",
    handle: "CatPalsPlus",
    url: "https://www.facebook.com/CatPalsPlus",
    icon: Facebook,
    color: "bg-blue-600 hover:bg-blue-700",
    hoverColor: "hover:text-blue-400"
  },
  instagram: {
    name: "Instagram",
    handle: "@CatPals_Plus",
    url: "https://www.instagram.com/CatPals_Plus",
    icon: Instagram,
    color: "bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400",
    hoverColor: "hover:text-pink-400"
  },
  x: {
    name: "X",
    handle: "@CatPals_Plus",
    url: "https://x.com/CatPals_Plus",
    icon: XIcon,
    color: "bg-black hover:bg-gray-800",
    hoverColor: "hover:text-white"
  }
};

// Get all social accounts as array
export const getSocialAccountsList = () => Object.values(SOCIAL_ACCOUNTS);
